const SDK_VERSION = "10.55.0" ;

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
